import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";
import * as actions from '../Actions'
import ShareOptions from '../ShareOptions';

export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  var eleRef = props.eleRef;
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: false,
        slidesPerView: (data && data.data.length > 1)?1.5:1,
        spaceBetween: 20,
         breakpoints: {
        767: {
          slidesPerView: (data && data.data.length > 1)?1.1:1,
          spaceBetween: 8
        },
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  const regex = /(<([^>]+)>)/ig;
  // const result = item.post[0].replace(regex, '');


  return (
    <div>
      <ReactIdSwiper {...params}>
        {data.data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ?
            <div className={data && data.data.length > 1 ? "swiper-slide_feed " : "swiper-slide_feed singleView"} key={idx}>
                <div className="new_blog_post__main_content">
                  <div className="blogpost_feed_new">
                    <div className="baby_posts_name_new_text">
                       <div className="baby_posts_name_new_profile"> 
                           <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png" alt="Default Profile Icon" title="Default Profile Icon"/> 
                       </div>
                       <div className="baby_posts_name_new_profile_content"> 
                         <div className="M14_42 fc_pd_px">{item.post[0].writerName?item.post[0].writerName:''} </div>
                         <div className="post_delevery R13_42"> {item.post[0].writerProfile?item.post[0].writerProfile:''} </div>
                       </div>
                    </div>
                     <div className="post_blog_seen_ago_text R14_9e"> 
                       <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/bookmark.png" alt="logo" className="writeForUs-bookmark"/> 
                     </div>
                 </div>
                 <div className="post_blog_read_test">
                 <h2 className="M18_21"> {item.post[0].postitle?item.post[0].postitle:''}</h2>
                  <div className="my_baby_question_ask"> 
                    <span className="my_baby_question_disc R15_42"> 
                    <div dangerouslySetInnerHTML={ {__html: item.post[0].posttext?item.post[0].posttext:''} } />
                    {/* {item.post[0].posttext?item.post[0].posttext:''}  */}
                    </span>
                  </div>
                   <a href={item.post[0].articleUrl?item.post[0].articleUrl:''}  className="readmorelink R14_link gtm-writeForUs-seeMore"> See More</a>
                   </div>
                     <div className="baby-week-social-view"> 
                        <div className="post-options">
                        <div className={item.post[0].isLiked ? "icon left likeicon isliked" : "icon left likeicon R14_61"} > 
                            <span className="icon likesIcon gtm-writeForUs-like" data-icon-font="" onClick={(e) => actions.likeArticle(item.post[0].articleId, e, item.post[0].likeCount)}></span> 
                            <span className="icons-text R13_61" onClick={(e) => actions.getAnswerLikeUsersArticle(e,item.post[0].articleId,item.post[0].likeCount)}>{item && item.post[0] ? item.post[0].likeCount : ''} <span className='mLike'>Likes</span></span> 
                          </div>
                           {/* <div className="icon left" data-icon-font=""> <span className="icons-text R13_61"> {item.post[0].likeCount?item.post[0].likeCount:'0'} </span> </div> */}
                          <div className="icon left devMemoLike font-sizeview R14_61" data-icon-font="$"> <span className="icons-text R13_61"> {item.post[0].viewCount?item.post[0].viewCount:'0'}</span> </div>
                          <div className="icon left kids_comment_before_icons_st R14_61 gtm-writeForUs-comment" data-icon-font="e"> <span className="icons-text R13_61"> {item.post[0].commentCount?item.post[0].commentCount:'0'} </span> </div> 
                          <div className="m-abuse-main right writeForUs" id={`share_${item.post[0].articleId}`}>
                            <div className="mCenter">
                           <div className="icon left icon3dot facebookicons" data-icon-font="J"></div>
                           <div className="icon left icon3dot whatsapp-icons" data-icon-font=""> <span className="icons-text R14_61 cursor-pointer gtm-writeForUs-share" onClick={() => actions.shareOn(item.post[0].articleId)}> Share </span></div>
                            <ShareOptions feedItem={data} eleRef={item.post[0]} />
                            </div>
                            </div>
                        </div>
                        
                    </div> 
                </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev}>
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext}>
          Next
        </button>
      </div>
    </div>
  );
};
